<template>
    <div class="content">
        <p class="title">招聘公告</p>
        <div style="padding:0 15px">
            <el-table
            :data="tableData"
            :header-cell-style="tablehead"
            border
            style="width: 100%">
                <el-table-column
                prop="title"
                label="标题">
                </el-table-column>
                <el-table-column
                prop="create_time_str"
                label="招聘时间"
                width="220">
                </el-table-column>
                <el-table-column
                prop="operation"
                label="操作"
                width="180">
                <template slot-scope="scope">
                    <el-button
                    type="text"
                    @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                class="pagination"
                layout="prev, pager, next,total"
                :total="total"
                @current-change="current_change">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
      return {
        tableData: [],
        total:0,
        pagesize:10,
        currentPage:1
      }
    },
    created(){
        this.getRecruitment()
    },
    methods:{
        tablehead(){
            return 'background: #F5F7FA;color:#909399;'
        },
        getRecruitment(){
            // 招聘公告cate_id=1，门户port_id=8
            this.$axios
            .get(this.$api.getlist,
                {port_id:8,cate_id:1,page:this.currentPage,plimit:this.pagesize})
            .then((res) => {
                let data=res.result.data
                this.tableData=data
                this.total= res.result.total
            });
        },
        handleEdit(index, row) {
            this.$router.push('/recruitment/info?id='+row.id)
        },
        current_change(currentPage){
            this.currentPage = currentPage;
            this.getRecruitment()
        }
    }
}
</script>

<style scoped>
    .content{
        width: 1280px;
        min-height: calc(100vh - 230px);
        margin: 0 auto;
        padding: 30px 0;
    }
    .title{
        line-height: 26px;
        font-size: 16px;
        color: #666;
        font-weight: 400;
        margin-bottom: 25px;
    }


    .el-button--text{
        color: #333;
    }
    .el-button--text:hover{
        color: #409EFF;
        text-decoration: underline;
    }
    .pagination{
        text-align: center;
        padding: 15px 30px;
    }

</style>